module.exports = __webpack_public_path__ + "img/icon-electrical-cabinet.2f0f7dac.svg";